import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import InfoBox from '@/components/InfoBox';

const ProposalWorkersProjection = ({ value, ...rest }) => {
  const { t } = useTranslation('proposalRequest');
  
  return (
    <div className="flex md:flex-row flex-col md:items-center">
      <div className="md:w-64">
        <InputNumber value={value} size={'large'} placeholder={t('amountPlaceHolder')} min={1} max={100} {...rest}/>
      </div>
      <div className="md:w-3/5 md:ml-4">
        <InfoBox title={'proposalRequest.form.partners.workersProjection.help'} translate={'proposalRequest'}/>
      </div>
    </div>
  );
};

ProposalWorkersProjection.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
};

ProposalWorkersProjection.defaultProps = {};

export default memo(ProposalWorkersProjection);
